import React from 'react';
import {calculateStrokeDashoffset} from "common/hook/calcul";

interface RadialStatisticItemProps {
    label: string;
    value: number | undefined;
    gradientId: string;
    id: string;
}

export const RadialStatisticItemSmall: React.FC<RadialStatisticItemProps> = ({ label, value, gradientId, id }) => (
    <div className="radial-statistic-item">
        <div className="radial-statistic small">
            <span className="percents">{value}%</span>
            <svg width="60" height="60" className="radial-progress">
                <linearGradient id="linearColors" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0%" stop-color="rgba(193, 232, 111, 1)"></stop>
                    <stop offset="50%" stop-color="rgba(239, 231, 45, 1)"></stop>
                    <stop offset="100%" stop-color="rgba(255, 110, 109, 1)"></stop>
                </linearGradient>
                <circle
                    r="24"
                    cx="26"
                    cy="26"
                    className="external-circle"
                    stroke-width="4"
                    fill="#fff"
                    stroke="url(#linearColors)"
                    strokeDashoffset={value !== undefined ? calculateStrokeDashoffset(value) : '0'}
                    id={id}
                ></circle>
            </svg>
        </div>
        <span className="radial-statistic-text">{label}</span>
    </div>
);

